<div class="custom-pt custom-container" [ngClass]="sessionData.storeImpersonation ? 'impersonation-height' : ''">
  @if (!isLoading && sessionData) {
  <app-main-heading-subtext headingText="Udsendelser" subText="{{
     sessionData.store
      ? 'Denne side giver dig et overblik over alle dine udsendelser. Dem der er gemt som kladde, afventer godkendelse, er blevet godkendt mm. Brug filtrene for nemt at sortere og finde specifikke udsendelser.'
      : 'Denne side giver dig mulighed for at administrere de enkelte udsendelser. Godkende såvel som redigere eller afvise udsendelser. Brug sektionerne til at se, hvilke udsendelser der afventer, er godkendt, afvist eller afsluttet.'
    }}" extraClasses="activity-margin"></app-main-heading-subtext>
  <div class="mb-5">
    <app-stroked-button [routerLink]="['/sendout/create/select-template']" [queryParams]="{ 'multiStore': true }" buttonText="Opret udsendelse til flere butikker"></app-stroked-button>
  </div>
  <div class="d-flex align-items-center justify-content-between mb-5">
    <app-search-field placeholder="Søg Udsendelser" (valueChange)="applySearchFilter($event)"></app-search-field>
    <div style="flex: 1 1 auto;"></div>
    <div style="margin-left: 20px;">
      Periode <mat-button-toggle-group appearance="standard" [hideSingleSelectionIndicator]="true">
        @for (p of lookbackOptions; track $index) {
        <mat-button-toggle class="lookback-period-toggle" [checked]="selectedLookback == p" [value]="p" (change)="handleLookbackChanged(p)">{{ p.label }}</mat-button-toggle>
        }
      </mat-button-toggle-group>

    </div>
    <div style="margin-left: 20px;">
      <mat-slide-toggle [(ngModel)]="slideToggleState" labelPosition="before">Gruppér</mat-slide-toggle>
    </div>
  </div>


  @if (slideToggleState) {
  <mat-accordion multi>
    @for (group of sendoutsAccordion.groups; track group.id; let first = $first) {
    <mat-expansion-panel [expanded]="first">
      <mat-expansion-panel-header>
        <mat-panel-title class="text-capitalize">
          {{ group.label }} ({{ group.entities.length }})
        </mat-panel-title>
      </mat-expansion-panel-header>

      @if (group.entities.length == 0) {
      <div class="empty-state-label">{{ emptyStateText }}</div>
      }
      @else {
      <app-sendout-table [columns]="columns" [data]="group.entities" (clickEvent)="sendoutClick($event)" [emptyStateText]="emptyStateText"></app-sendout-table>
      }
    </mat-expansion-panel>
    }
  </mat-accordion>
  } @else {
  <div style="padding: 0 24px;">
    <app-sendout-table [columns]="columns" [data]="sendouts" (clickEvent)="sendoutClick($event)" [emptyStateText]="emptyStateText"></app-sendout-table>
  </div>
  }
  } @else {
  <app-skeleton></app-skeleton>
  }
</div>
